module.exports = {"physical":"Physical","holy":"Holy","fire":"Fire","nature":"Nature","frost":"Frost","shadow":"Shadow","arcane":"Arcane"};